<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="sa-nw-reference-modal"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="font-weight-bold mb-3">
              こちらの内容でCPA 5G SAを解約します。よろしいですか？<br />
              <template v-if="cpaContractInfo.wnumber">
                登録されている認証IDについても同時に削除されます。
              </template>
            </div>
            <!-- 契約情報 : 契約情報、基本情報、NW設定状況 -->
            <sa-nw-contract-info :cpaContractInfo="cpaContractInfo" />

            <!-- 設定情報 : NW設定共通、 NW設定(ACT・SBY)、保守連絡先、その他項目、テストアカウント -->
            <sa-nw-setting-info
              v-if="cpaContractInfo.wnumber"
              :cpaContractInfo="cpaContractInfo"
              :nwSettingDetail="nwSettingDetail"
              :nwOptions="nwOptions"
            />
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい </v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import SaNwContractInfo from "@/components/cpa5gSa/SaNwContractInfo.vue";
import SaNwSettingInfo from "@/components/cpa5gSa/SaNwSettingInfo.vue";
import type { CpaContract, CpaNwDetail, CpaNwOptions } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaNwContractDeleteConfirm",
  components: { SaNwContractInfo, SaNwSettingInfo },
  props: {
    /** CPA契約情報 */
    cpaContractInfo: {
      type: Object as PropType<CpaContract>,
      required: true,
    },
    /** CPA NW 詳細情報 */
    nwSettingDetail: {
      type: Object as PropType<CpaNwDetail>,
      required: true,
    },
    /** CPA特殊項目設定情報 */
    nwOptions: {
      type: Object as PropType<CpaNwOptions>,
      required: true,
    },
  },
});
</script>
